import Routing from '../core/router/router';

import { HTTP } from '../core/http/http-token';
import { HTTP_FILES } from '../core/http/http-file-common';
import i18n from '../i18n/index.js';
import state from '../store/modules/paramsClient-data.js';
import routeSate from '../store/modules/route-data.js';
import commonData from '../store/modules/common-data.js';

let self = this;
const urlParams = new URLSearchParams(window.location.search);
const lang = urlParams.get('lang') ? urlParams.get('lang') : 'fr';
i18n.locale = lang;
let storage_init = {
  i18n: {
    locale: 'fr',
    messages: {
      fr: {

        // Here just as a reference, GrapesJS core doesn't contain any block,
        // so this should be omitted from other local files
        blockManager: {
          labels: {
            // 'block-id': 'Block Label',
          },
          categories: {
            // 'category-id': 'Category Label',
          }
        },
        domComponents: {
          names: {
            '': 'Box',
            wrapper: 'Body',
            text: 'Text',
            comment: 'Comment',
            image: 'Image',
            video: 'Video',
            label: 'Label',
            link: 'Link',
            map: 'Map',
            tfoot: 'Table foot',
            tbody: 'Table body',
            thead: 'Table head',
            table: 'Table',
            row: 'Table row',
            cell: 'Table cell'
          }
        },
        deviceManager: {
          device: 'Device',
          devices: {
            desktop: 'Desktop',
            tablet: 'Tablet',
            mobileLandscape: 'Mobile Landscape',
            mobilePortrait: 'Mobile Portrait'
          }
        },
        panels: {
          buttons: {
            titles: {
              preview: 'Aperçu',
              fullscreen: 'Plein écran',
              'sw-visibility': 'View components',
              'open-tm': 'Paramètres',
              'open-sm': 'Gestionnaire de style',
              'open-layers': 'Layers',
              'open-blocks': 'Blocs',
            }
          }
        },
        selectorManager: {
          label: 'Classes',
          selected: 'Selected',
          emptyState: '- State -',
          states: {
            hover: 'Hover',
            active: 'Click',
            'nth-of-type(2n)': 'Even/Odd'
          }
        },
        styleManager: {
          empty: 'Sélectionnez un élément avant d\'utiliser le Gestionnaire de styles',
          layer: 'Layer',
          fileButton: 'Images',
          sectors: {
            general: 'General',
            layout: 'Layout',
            typography: 'Typography',
            decorations: 'Decorations',
            extra: 'Extra',
            flex: 'Flex',
            dimension: 'Dimension'
          },
          // The core library generates the name by their `property` name
          properties: {
            // float: 'Float',
          }
        },
        traitManager: {
          empty: 'Sélectionnez un élément avant d\'utiliser Trait Manager',
          label: 'Component settings',
          traits: {
            // The core library generates the name by their `name` property
            labels: {
              // id: 'Id',
              // alt: 'Alt',
              // title: 'Title',
              // href: 'Href',
            },
            // In a trait like select, these are used to translate option names
            options: {
              target: {
                false: 'This window',
                _blank: 'New window'
              }
            }
          }
        }
      },
    }
  },
  height: '100%',
  container: '#gjs',
  style: '',
  protectedCss:
    '.gjs-hovered{width: unsetnone;height: unsetnone;}[data-class="custom-credit"], .custom-credit{z-index: 9999!important ; font-size: 20pt;font-family:  Din Regular ;  left: 0%!important; bottom: 1%!important; top: auto!important; text-align: center;padding: 10px 0.2em;color: #252e63;    width: auto!important; height: auto!important;  }[data-rotation="vertical"]{writing-mode: vertical-rl;text-orientation: mixed;transform: rotate(-180deg);}div[data-class="custom-sharing"]{  font-family:  Din Bold !important; }video{background-color: black;}[emp-data-class="emp-text"]{ color: #252e63; }[data-gjs-type="countdown"]{padding: 0.2em;}[data-gjs-type="filet"]{ left: 50% !important;} a:-webkit-any-link {color: inherit !important; text-decoration: none !important;}p{margin:0}a {pointer-events:none;} span[data-cke-magic-line] {\n' +
    '    display: none!important;\n' +
    '}',
  fromElement: 1,
  showOffsets: 0,
  assetManager: {
    uploadText: i18n.t('blocks.drop_files'),
    modalTitle: i18n.t('blocks.select_image'),
    embedAsBase64: 1,
    uploadFile: function (e) {
      var files = e.dataTransfer ? e.dataTransfer.files : e.target.files;
      for (var i in files) {
        var formData = new FormData();
        formData.append('empApiFileForm[thumb]', files[i]); //containing all the selected images from local
        HTTP_FILES(window.ApiToken)
          .post(Routing.generate('api_bloc_post_thumb'), formData)
          .then(
            function (response) {
              if (response && response.data && response.data.code == 200) {
                var image = response.data.location.url;
                for (i = 0; i < grapesjs.editors.length; i++) {
                  grapesjs.editors[i].AssetManager.add(image);
                }
              }
            },
            function (response) {
              //self.hideLoader();
            },
          );
      }
    },
    assets: [],
  },
  richTextEditor: {
    autoEdit: false
  },
  tagVarStart: '{[ ',
  tagVarEnd: ' ]}',
  plugins: [
    'gjs-preset-webpage',
    'grapesjs-lory-slider',
    'display-facebook-plugin',
    'display-linkedin-plugin',
    'display-rss-plugin',
    'display-web-plugin',
    'display-playlist-plugin',
    'display-player-plugin',
    'display-live-plugin',
    'display-twitter-plugin',
    'display-weather-plugin',
    'display-filet-plugin',
    'display-clock-plugin',
    'display-webrtc-plugin',
    'display-ticker-plugin',
    'display-dateHeure-plugin',
    'display-image-plugin',
    'display-player-mp4-plugin',
    'display-social-media-plugin',
    'display-pattern-plugin',
  ],
  pluginsOpts: {
    'grapesjs-lory-slider': {
      sliderBlock: {
        category: 'Extra',
      },
    },
    'gjs-preset-webpage': {
      modalImportTitle: 'Import Template',
      modalImportLabel:
        '<div style="margin-bottom: 10px; font-size: 13px;">' + i18n.t('past_css') + '</div>',
      modalImportContent: function (editor) {
        return editor.getHtml() + '<style>' + editor.getCss() + '</style>';
      },
      filestackOpts: { key: 'AYmqZc2e8RLGLE7TGkX3Hz' },
      aviaryOpts: false,
      countdownOpts: {
        startTime: '2020-12-12 00:00',
        labelCountdownCategory: 'Widget',
        endText: i18n.t('blocks.endText'),
        labelDays: i18n.t('blocks.labelDays'),
        labelHours: i18n.t('blocks.labelHours'),
        labelMinutes: i18n.t('blocks.labelMinutes'),
        labelSeconds: i18n.t('blocks.labelSeconds'),
        defaultStyle: false,
      },
      blocksBasicOpts: { flexGrid: 1 },
      customStyleManager: [],
    },

    'display-player-plugin': {
      api_routing: 'api_media_get_media',
      http: HTTP,
      routing: Routing,
      client: state.state,
      translate: i18n.t('display-player-plugin'),
    },
    'display-image-plugin': {
      api_params_display: 'api_programDisplay_get_params_display',
      http: HTTP,
      routing: Routing,
      route: routeSate.state,
      translate: i18n.t('display-image-plugin'),
    },
    'display-pattern-plugin': {
      api_params_display: 'api_programDisplay_get_params_display',
      http: HTTP,
      routing: Routing,
      route: routeSate.state,
      translate: i18n.t('display-pattern-plugin'),
    },
    'display-social-media-plugin': {
      route: state.state,
    },
    'display-player-mp4-plugin': {
      api_routing: 'api_media_get_media',
      http: HTTP,
      routing: Routing,
      client: state.state,
      translate: i18n.t('display-player-plugin'),
    },
    'display-live-plugin': {
      api_routing_live: 'api_get_live_pagination',
      http: HTTP,
      routing: Routing,
      client: state.state,
      translate: i18n.t('blocks.select_video'),
    },

    'display-facebook-plugin': { state: state.state },
    'display-twitter-plugin': { state: state.state },
    'display-linkedin-plugin': { state: state.state },

    /*Todo change api routing playlist*/
    'display-playlist-plugin': {
      api_routing_playlist: 'api_get_list_playlists_pagination',
      http: HTTP,
      routing: Routing,
      client: state.state,
      translate: i18n.t('blocks.select_video'),
    },
    'display-weather-plugin': {
      translate: i18n.t('display-weather-plugin'),
    },
    'display-clock-plugin': {
      translate: i18n.t('display-clock-plugin'),
    },
    'display-dateHeure-plugin': {
      translate: i18n.t('display-clock-plugin'),
    },
    'display-ticker-plugin': {
      translate: i18n.t('display-ticker-plugin'),
    },
  },
  storageManager: {
    id: 'gjs-', // Prefix identifier that will be used inside storing and loading
    type: 'local', // Type of the storage
    autosave: true, // Store data automatically
    autoload: true, // Autoload stored data on init
    stepsBeforeSave: 1, // If autosave enabled, indicates how many changes are necessary before store method is triggered
    storeComponents: true, // Enable/Disable storing of components in JSON format
    storeStyles: true, // Enable/Disable storing of rules/style in JSON format
    storeHtml: true, // Enable/Disable storing of components as HTML string
    storeCss: true, // Enable/Disable storing of rules/style as CSS string
  },
  styleManager: {
    textNoElement: "Sélectionner un élément avant d'utiliser le Gestionnaire de styles",
  },
  canvas: {
    customBadgeLabel: function (c) {
      try {
        if (c.attributes.attributes['data-class'] == 'custom-sharing') return 'Link';
        if (c.attributes.attributes['data-class'] == 'custom-title') return 'Title';
        if (c.attributes.attributes['data-class'] == 'custom-credit') return 'Credit';
      } catch (e) {
        return c.getName();
      }
      return c.getName();
    },
    scripts: [
      'display/plugins/ticker/jquery.min.js',
      'display/plugins/ticker/ticker.min.js',
      'display/static/js/mouse-events.js',
      'display/static/js/froogaloop2.min.js',
    ],
    styles: [
      'display/plugins/ticker/ticker.css',
      'display/plugins/clock/clock.css',
      'display/plugins/weather/weather.css',
      // Police d'icônes des cartes pays du widget météo (glyphe .pays-icon-fr).
      // Sans elle le bloc carte s'effondre (hauteur 0) et décale la température.
      'display/static/css/pays-icon.css',
      'display/static/css/fonts.css',
      'display/static/css/text-animation.css',
      'display/static/css/countdown.css',
      'display/plugins/dateHeure/dateHeure.css',
      'display/static/socialMedia.css',
      'display/plugins/weather/weather.css',
    ],
  },
};
export default storage_init;



// WEBPACK FOOTER //
// ./src/storage/grapes-init.js